import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import GFCSpendByMonth from "../../../assets/components/reports/GFCSpendByMonth";

class GFCSpendByMonthReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>GFC Spend By Month</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <GFCSpendByMonth />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default GFCSpendByMonthReport;
